module.exports = __webpack_public_path__ + "media/images/icons/chat-710512ecfb1456c90df4fcd5b0ebb941.svg";